export default "__VITE_ASSET__DhFpm7sj__ 400w, __VITE_ASSET__MkYtXDy9__ 800w, __VITE_ASSET__CNwTa_70__ 1024w";